import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, Validators, FormControl } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { FileUploader } from "ng2-file-upload";
import { DataSource } from "@angular/cdk/table";
import { BorrowerService } from "../borrower/borrower.service";
import { SessionService } from "../service/session.service";

import { Router, ActivatedRoute } from "@angular/router";
export interface UserData {
    id: string;
    name: string;
    email: string;
    lastLogin: Date;
    GCNetwork: string;
    FirstName: string;
}

/** Constants used to fill up our data base. */
const COLORS: string[] = [
    "maroon",
    "red",
    "orange",
    "yellow",
    "olive",
    "green",
    "purple",
    "fuchsia",
    "lime",
    "teal",
    "aqua",
    "blue",
    "navy",
    "black",
    "gray",
];
const NAMES: string[] = [
    "Maia",
    "Asher",
    "Olivia",
    "Atticus",
    "Amelia",
    "Jack",
    "Charlotte",
    "Theodore",
    "Isla",
    "Oliver",
    "Isabella",
    "Jasper",
    "Cora",
    "Levi",
    "Violet",
    "Arthur",
    "Mia",
    "Thomas",
    "Elizabeth",
];

/**
 * @title Data table with sorting, pagination, and filtering.
 */
const URL = "https://evening-anchorage-3159.herokuapp.com/api/";
@Component({
    selector: "app-consultant",
    templateUrl: "./consultant.component.html",
    styleUrls: ["./consultant.component.scss"],
})
export class ConsultantComponent implements OnInit {
    public uploader: FileUploader = new FileUploader({ url: URL });
    displayedColumns: string[] = [
        "id",
        "FirstName",
        "name",
        "email",
        "lstLogin",
    ];
    loading = false;

    dataSource: MatTableDataSource<UserData>;
    mobnumPattern = "^(d{3})sd{3}-d{4}";
    add_contractor = new FormGroup({
        email: new FormControl(null, [Validators.required, Validators.email,Validators.maxLength(40),Validators.minLength(5)]),
        fname: new FormControl(null, [Validators.required,Validators.maxLength(30),Validators.minLength(3)]),
        lname: new FormControl(null, [Validators.required,Validators.maxLength(30),Validators.minLength(3)]),
        // phone_no: new FormControl(null,[Validators.pattern(this.mobnumPattern), Validators.maxLength(15),Validators.minLength(8)]),
        phone_no: new FormControl(null,[]),
        statusType: new FormControl(null, [Validators.required]),
        password: new FormControl(null, [Validators.required, Validators.maxLength(15),Validators.minLength(4)]),
        confirmPassword: new FormControl(null, [Validators.required, Validators.maxLength(15),Validators.minLength(4)]),
        license: new FormControl(null),
        IDNumber: new FormControl(null),
        leadSafe: new FormControl(null),
        areas: new FormControl(null),
        gcnetwork: new FormControl(null),
        signature: new FormControl(null),
        country: new FormControl("us"),
        city: new FormControl(null),
        state: new FormControl(null),
        zipcode: new FormControl(null, [Validators.maxLength(10),Validators.minLength(3)]),
        address1: new FormControl(null),
        address2: new FormControl(null),
        id: new FormControl(null),
    });

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    isList: boolean = true;
    isAdd: boolean = false;
    isEdit: boolean = false;
    submitted: boolean = false;
    favoriteSeason: string;
    userDetail: any = {};
    userList: any = {};
    formattedaddress = "";
    options = {
        componentRestrictions: {
            country: ["US"],
        },
    };
    status: any = ["Blocked", "Active"];
    roles: any = [
        { Key: "1", Value: "authenticated user" },
        { Key: "2", Value: "Administrator" },
        { Key: "3", Value: "Consultants" },
        { Key: "4", Value: "General Contractors" },
        { Key: "5", Value: "Borrower" },
        { Key: "6", Value: "Loan Officer" },
        { key: "7", Value: "Loan Processor" },
        { key: "8", Value: " Notify user of new account" },
        { key: "9", Value: "Draw Administrator" },
    ];
    maskPhoneFormat: any = '(000) 000-0000';
    constructor(
        private _bservice: BorrowerService,
        private sessionService: SessionService,
        private router: Router,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        if (this.sessionService.get("userInfo") != undefined) {
            this.userDetail = JSON.parse(this.sessionService.get("userInfo"));
        }
        this.GetUserList();
    }

    keyDownPhoneFormat($event) {
        var key = $event.keyCode;

        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
            return;
        }
        this.changePhoneFormat($event);
    }

    changePhoneFormat($event) {
        var getVal = $event.target.value;
        var tel = getVal.replace(/[^0-9]/g, "");
        $event.target.value = this.changeFilter(tel);
    }
    changeFilter(tel) {
        if (!tel) {
            return "";
        }

        var value = tel.toString().trim().replace(/^\+/, "");

        if (value.match(/[^0-9]/)) {
            return tel;
        }

        var country, city, number;

        switch (value.length) {
            case 1:
            case 2:
            case 3:
                city = value;
                break;

            default:
                city = value.slice(0, 3);
                number = value.slice(3);
        }

        if (number) {
            if (number.length > 3) {
                number = number.slice(0, 3) + "-" + number.slice(3, 7);
            } else {
                number = number;
            }

            return ("(" + city + ") " + number).trim();
        } else {
            return "(" + city;
        }
    }

    public AddressChange(address: any) {
        let addressFielsLength = address.address_components.length;
        let address1 = "";

        let city = "";
        let state = "";
        let zipcode = "";

        for (let i = 0; i < addressFielsLength; i++) {
            if (address.address_components[i].types[0] == "street_number") {
                address1 = address.address_components[i].long_name;
            }

            if (address.address_components[i].types[0] == "route") {
                address1 =
                    address1 + " " + address.address_components[i].long_name;
            }

            if (
                address.address_components[i].types[0] ==
                    "sublocality_level_1" ||
                address.address_components[i].types[0] == "locality" ||
                address.address_components[i].types[0] == "neighborhood"
            ) {
                city = address.address_components[i].long_name;
            }
            if (
                address.address_components[i].types[0] ==
                "administrative_area_level_1"
            ) {
                state = address.address_components[i].short_name;
            }
            if (address.address_components[i].types[0] == "postal_code") {
                zipcode = address.address_components[i].long_name;
            }
        }

        this.add_contractor.controls["address1"].setValue(address1);

        this.add_contractor.controls["city"].setValue(city);
        this.add_contractor.controls["state"].setValue(state);
        this.add_contractor.controls["zipcode"].setValue(zipcode);
    }
    applyFilter(filterValue) {
        const target = filterValue as HTMLInputElement;
        const targetValue = target.value;
        this.dataSource.filter = targetValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    showAddForm() {
        this.isAdd = true;
        this.isList = false;
    }

    contractorList() {
        this.isEdit = false;
        this.isList = true;
    }
    ValidatePartnerPass() {
        let password = this.add_contractor.controls.password.value;
        let repeatPassword = this.add_contractor.controls.confirmPassword.value;

        if (repeatPassword !== password) {
            this.add_contractor.controls["confirmPassword"].setErrors({
                incorrect: true,
            });
        } else {
            this.add_contractor.controls["confirmPassword"].setErrors(null);
        }
    }
    SaveContractor() {
        if (this.add_contractor.invalid) {
            return;
        } else {
            this.submitted = false;
            var formData = this.add_contractor.value;
            if (formData.id == null && !this.isEdit) {
                this.loading = true;
                var data = {
                    EmailId: formData.email,
                    Password: formData.password,
                    UserType: this.sessionService.userType[2].Value,
                    FirstName: formData.fname,
                    LastName: formData.lname,
                    Status: formData.statusType,
                    Phone: formData.phone_no,
                    IDNumber: formData.IDNumber,
                    Signature: formData.signature,
                    ContractorLicense: formData.license,
                    LeadSafeCertified: formData.leadSafe,
                    ServiceAreas: formData.areas,
                    GCNetwork: formData.gcnetwork,
                    CreatedBy: this.userDetail.EmailId,
                    Address1: formData.address1,
                    Addresss2: formData.address2,
                    City: formData.city,
                    State: formData.state,
                    Zip: formData.zipcode,
                    Country: formData.country,
                };
                this._bservice.AddBorrower(data).subscribe(
                    (response) => {
                        this.sessionService.notifier.notify(
                            "success",
                            "Consultant added successfully."
                        );
                        this.isList = true;
                        this.isAdd = false;
                        this.GetUserList();
                        this.loading = false;
                    },
                    (error) => {
                        this.sessionService.notifier.notify(
                            "error",
                            error.error.message
                        );
                        this.loading = false;
                    }
                );
            } else {
                this.loading = true;
                var data1 = {
                    EmailId: formData.email,
                    Password: formData.password,
                    UserType: this.sessionService.userType[2].Value,
                    FirstName: formData.fname,
                    LastName: formData.lname,
                    Status: formData.statusType,
                    Phone: formData.phone_no,
                    IDNumber: formData.IDNumber,
                    Signature: formData.signature,
                    ContractorLicense: formData.license,
                    LeadSafeCertified: formData.leadSafe,
                    ServiceAreas: formData.areas,
                    GCNetwork: formData.gcnetwork,
                    CreatedBy: this.userDetail.EmailId,
                    Id: formData.id,
                    Address1: formData.address1,
                    Addresss2: formData.address2,
                    City: formData.city,
                    State: formData.state,
                    Zip: formData.zipcode,
                    Country: formData.country,
                };
                this._bservice.UpdateBorrower(data1).subscribe(
                    (response) => {
                        this.sessionService.notifier.notify(
                            "success",
                            "Consultant updated successfully."
                        );

                        this.isList = true;
                        this.isAdd = false;
                        this.isEdit = false;
                        this.formReset();
                        this.GetUserList();
                        this.loading = false;
                    },
                    (error) => {
                        this.sessionService.notifier.notify(
                            "error",
                            error.error.message
                        );
                        this.loading = false;
                    }
                );
            }
        }
    }

    nextPage(event: PageEvent) {}

    GetUserList() {
        this.loading = true;
        var data = {
            EmailId: "",
            PageSize: 100000,
            LastEvaluatedKey: 0,
            UserType: this.sessionService.userType[2].Value,
        };
        this._bservice.GetUserList(data).subscribe(
            (response) => {
                if (response != null) {
                    this.userList = response;
                    this.userList.Items.sort(function (a, b) {
                        return a.Id < b.Id ? 1 : -1;
                    });
                    const users = Array.from(
                        { length: this.userList.Count },
                        (_, k) => createNewUser(k, this.userList)
                    );
                    this.dataSource = new MatTableDataSource(users);
                    this.dataSource.paginator = this.paginator;

                    this.loading = false;
                }
            },
            (error) => {}
        );
    }

    deleteUser(userid) {
        if (confirm("Are you sure to delete consultant")) {
            this._bservice.DeleteUser(userid).subscribe(
                (response) => {
                    this.sessionService.notifier.notify(
                        "success",
                        "Consultant deleted successfully."
                    );

                    this.isList = true;
                    this.isAdd = false;
                    this.isEdit = false;
                    this.formReset();
                    this.GetUserList();
                    this.loading = false;
                },
                (error) => {
                    this.sessionService.notifier.notify(
                        "error",
                        error.error.message
                    );
                    this.loading = false;
                }
            );
            window.scroll(0, 0);
        }
    }

    EditUser(item) {
        this.isEdit = true;
        this.isList = false;
        this.add_contractor.setValue({
            email: item.EmailId,
            fname: item.FirstName,
            lname: item.LastName,
            phone_no: item.Phone == undefined ? null : item.Phone,
            statusType: item.Status,

            password: item.Password,
            confirmPassword: item.Password,
            id: item.Id,
            license:
                item.ContractorLicense == undefined
                    ? ""
                    : item.ContractorLicense,
            leadSafe:
                item.LeadSafeCertified == undefined
                    ? ""
                    : item.LeadSafeCertified,
            gcnetwork: item.GCNetwork,
            areas: item.ServiceAreas == undefined ? "" : item.ServiceAreas,
            signature: item.Signature == undefined ? "" : item.Signature,
            IDNumber: item.IDNumber == undefined ? "" : item.IDNumber,
            country: item.Country == undefined ? "" : item.Country,
            city: item.City == undefined ? "" : item.City,
            state: item.State == undefined ? "" : item.State,
            zipcode: item.Zip == undefined ? "" : item.Zip,
            address2: item.Addresss2 == undefined ? "" : item.Addresss2,
            address1: item.Address1 == undefined ? "" : item.Address1,
        });
    }

    formReset() {
        this.add_contractor.reset();
        this.add_contractor.controls["statusType"].setValue("Active");
    }
}

/** Builds and returns a new User. */
function createNewUser(id: number, userList): UserData {
    const name =
        NAMES[Math.round(Math.random() * (NAMES.length - 1))] +
        " " +
        NAMES[Math.round(Math.random() * (NAMES.length - 1))].charAt(0) +
        ".";
    if (userList.Items[id] != undefined) {
        userList.Items[id].id = id + 1;
        return userList.Items[id];
    }
}
